Backbone = require 'backbone'

class FAQContentModel extends Backbone.Model
  initialize: ->
    @baseUrl = "#{window.FAQBASEURL}/topics"
    @container = $('#content-container')
    @spinner = $('.g-spinner')
    @errorContainer = $('#error-container')

  setUrl : (queryParams) ->
    switch queryParams?.category
      when "topic"
        topicId = encodeURIComponent(queryParams.topicId)
        @url = "#{@baseUrl}/#{topicId}/articles?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"
      when "article"
        topicId = encodeURIComponent(queryParams.topicId)
        articleId = encodeURIComponent(queryParams.articleId)
        @url = "#{@baseUrl}/#{topicId}/articles/#{articleId}?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"

  # Makes a Server call to fetch the search results and maintains history
  fetchContent : (queryParams , sucessCallback, errorCallback) ->
    @setUrl(queryParams)
    @container.empty()
    @errorContainer.empty()
    @spinner.show()
    @fetch
      success: ( model, response, options ) =>
        stopTimer("t_fs")
        @spinner.hide()
        sucessCallback(response)
      error: ( model, xhr, options )  =>
        stopTimer("t_fs")
        @spinner.hide()
        errorCallback(queryParams)
    startTimer("t_fs")

module.exports = FAQContentModel
